import dynamic from 'next/dynamic'
import { PageType } from './cook'
import { ComponentType, FunctionComponent } from 'react'
import nanoid from '@utils/random'
const ArticleRegistryItem = dynamic(() => import('./ArticleRegistryItem'))
const SectionRegistryItem = dynamic(() => import('./SectionRegistryItem'))
const SectionToiRegistryItem = dynamic(() => import('./SectionToiRegistryItem'))

export interface JSONRendererProps {
  pageType: PageType
  children: any | any[]
}

const JSONRenderer: FunctionComponent<JSONRendererProps> = ({
  pageType,
  children,
}) => {
  let Component: ComponentType<{
    data: any
  }>

  switch (pageType) {
    case 'sectionToi': {
      Component = SectionToiRegistryItem
      break
    }
    case 'article': {
      Component = ArticleRegistryItem
      break
    }
    case 'section':
    default: {
      Component = SectionRegistryItem
      break
    }
  }

  const childrenAsArray = Array.isArray(children) ? children : [children]

  return (
    <>
      {childrenAsArray.map((childData: any) => (
        <Component key={nanoid()} data={childData} />
      ))}
    </>
  )
}

export default JSONRenderer
